import {
  START_LOADING, END_LOADING
} from "../actions/loading_actions";

const initialState = {
  isLoading: false
};

export const loadingReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING: {
      return {...state, isLoading: true}
    }
    case END_LOADING: {
      return {...state, isLoading: false}
    }
    default: return state;
  }
}
